const ESignJLLTModule = {
    namespaced: true,
    state: {
        refreshKey: null
    },
    actions: {
        REFRESH({ state, commit }, refreshKey) {
            commit('SetRefreshESignList', refreshKey);
        },
    },
    mutations: {
        SetRefreshESignList: function (state, refreshKey) {
            state.refreshKey = refreshKey;
        }
    },
    getters: {
        GetRefreshESignList: function (state) {
            try {
                return state.refreshKey;
            } catch (err) {
                return null;
            }
        },
    },
};
export default ESignJLLTModule;